import * as TYPES from './constants';

// GET
export const requestListPartnerDirectory = () => ({
  type: TYPES.REQUEST_LIST_OF_PARTNER_DIRECTORY,
});
export const receiveListPartnerDirectory = json => ({
  type: TYPES.RECEIVE_LIST_OF_PARTNER_DIRECTORY,
  payload: json,
});
export const ListPartnerDirectoryError = err => ({
  type: TYPES.LIST_OF_PARTNER_DIRECTORY_ERROR,
  err,
});

// POST
export const requestAddPartnerToDirectory = () => ({
  type: TYPES.REQUEST_ADD_PARTNER_TO_DIRECTORY,
});
export const receiveAddPartnerToDirectory = json => ({
  type: TYPES.RECEIVE_ADD_PARTNER_TO_DIRECTORY,
  payload: json,
});
export const AddPartnerToDirectoryError = err => ({
  type: TYPES.ADD_PARTNER_TO_DIRECTORY_ERROR,
  err,
});

// PATCH
export const requestUpdatePartnerToDirectory = () => ({
  type: TYPES.REQUEST_UPDATE_PARTNER_TO_DIRECTORY,
});
export const receiveListUpdatePartnerTODirectory = json => ({
  type: TYPES.RECEIVE_UPDATE_PARTNER_TO_DIRECTORY,
  payload: json,
});
export const UpdatePartnerToDirectoryError = err => ({
  type: TYPES.UPDATE_PARTNER_TO_DIRECTORY_ERROR,
  err,
});

// DELETE
export const requestDeletePartnerFromDirectory = () => ({
  type: TYPES.REQUEST_DELETE_PARTNER_FROM_DIRECTORY,
});
export const receiveListDeletePartnerFromDirectory = json => ({
  type: TYPES.RECEIVE_DELETE_PARTNER_FROM_DIRECTORY,
  payload: json,
});
export const DeletePartnerFromDirectoryError = err => ({
  type: TYPES.DELETE_PARTNER_FROM_DIRECTORY_ERROR,
  err,
});

// GET
export const requestPartnerDirectoryDetails = () => ({
  type: TYPES.REQUEST_PARTNER_DIRECTORY_DETAILS,
});
export const receivePartnerDirectoryDetails = json => ({
  type: TYPES.RECEIVE_PARTNER_DIRECTORY_DETAILS,
  payload: json,
});
export const PartnerDirectoryDetailsError = err => ({
  type: TYPES.PARTNER_DIRECTORY_DETAILS_ERROR,
  err,
});
